module Shared.Home.UpdateEmail

open Illy.SafeStack
open Shared

type DTO = 
    {
        Email: string option
        Password: string option
    }

module Validations = 
    open Illy.SafeStack.Validation
    open Illy.SafeStack.ROP
    open Illy.SafeStack.CompositionalValidation
    open Shared.Validations.Email
    open Shared.Validations.Password

    type EmailAddressValidations = 
        | EmailValidations of EmailValidations
        | CannotBeTheSameAsOldEmail

    module EmailAddressValidations = 
        let toString = 
            function 
            | EmailValidations v -> EmailValidations.toString v
            | CannotBeTheSameAsOldEmail -> "New email is the same as the old email."

    type UpdateEmailValidations = 
        | EmailAddressValidations of EmailAddressValidations
        | PasswordValidations of PasswordValidations

    module UpdateEmailValidations = 
        let toString = 
            function 
            | EmailAddressValidations v -> EmailAddressValidations.toString v
            | PasswordValidations v -> PasswordValidations.toString v

    let validateEmailAddress oldUserEmail email = 
        validate {
            return! (validateEmail >-> EmailAddressValidations.EmailValidations) email

            return! !!(error EmailAddressValidations.CannotBeTheSameAsOldEmail)
                >>= passIfNone email 
                >>= conditional pass (fun (_, eStr) -> eStr <> oldUserEmail)
                |> firstResult
        }

    let validateDTO oldEmail (dto: DTO) = 
        validate {
            return! (validateEmailAddress oldEmail >-> UpdateEmailValidations.EmailAddressValidations) dto.Email
            return! (validatePassword >-> UpdateEmailValidations.PasswordValidations) dto.Password
        }


type FailureReason =
    | FailedValidations of Validation.ValidationResult<Validations.UpdateEmailValidations, Validation.NoWarning>

